import { Component, Input } from '@angular/core';
import type { FormControl, FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { BehaviorSubject } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import { InputComponent } from '@core/user-interface-legacy';

import type { InputTypeComponent } from '../../advanced-filters/filter/types';

type InputRangeControl = FormGroup<{
  gte: FormControl<number | null>;
  lte: FormControl<number | null>;
}>;
type InputRange = InputTypeComponent<InputRangeControl, never, never>;

@Component({
  selector: 'rt-views-input-range',
  imports: [InputComponent, ReactiveFormsModule, TranslatePipe],
  templateUrl: './input-range.component.html',
  styleUrls: ['./input-range.component.less'],
})
export class InputRangeComponent implements InputRange {
  @Input() public inputControl: InputRange['inputControl'];
  @Input() public state: InputRange['state'] = null;
  @Input() public optionsData: InputRange['optionsData'];

  public state$ = new BehaviorSubject<null>(null);
}
